module.exports = "/images/vendor/flag-icon-css/flags/1x1/bz.svg?e6b5e204d3da700fbf9004584f69d6fa";